import React, { FC, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { FreeMode, Mousewheel } from 'swiper';
import classnames from 'classnames';
import { OpeningSearchTagNameEnum, OpeningStateEnum } from '@src/graphql/generated';
import { numberWithCommas } from '@src/util/numberWithCommas';
import { TabInterface } from './interfaces/tab.interface';
import { Filter } from './interfaces/filter.interface';
import { Skeleton } from './Skeleton';
import { OpeningStatesProps } from './props';
import './styles.scss';

export const FILTERS: Filter = {
  [OpeningStateEnum.ACTIVE]: {
    key: OpeningStateEnum.ACTIVE,
    label: 'Published',
    order: 1,
    searchTags: [
      { tag: OpeningSearchTagNameEnum.STATE, value: 'active' },
      { tag: OpeningSearchTagNameEnum.STATE, value: 'admin_review' },
    ],
  },
  [OpeningStateEnum.DRAFT]: {
    key: OpeningStateEnum.DRAFT,
    label: 'Draft',
    order: 2,
    searchTags: [{ tag: OpeningSearchTagNameEnum.STATE, value: 'draft' }],
  },
  [OpeningStateEnum.INACTIVE]: {
    key: OpeningStateEnum.INACTIVE,
    label: 'Inactive',
    order: 3,
    searchTags: [
      { tag: OpeningSearchTagNameEnum.STATE, value: 'inactive' },
      { tag: OpeningSearchTagNameEnum.STATE, value: 'paused' },
    ],
  },
};

export const OpeningStates: FC<OpeningStatesProps> = ({
  onFilterSelect,
  initialActiveTab,
  filtersResultsCount,
  isLoading,
}) => {
  const [activeTab, setActiveTab] = useState<TabInterface>(initialActiveTab || FILTERS.ACTIVE);
  const orderedFilters = Object.values(FILTERS).sort((a, b) => a.order - b.order);

  const onFilterChange = (activeTab: TabInterface): void => {
    setActiveTab(activeTab);
    onFilterSelect(activeTab);
  };

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <div className="filter-opening-state">
      <Swiper
        centeredSlides={false}
        freeMode={true}
        loop={false}
        modules={[FreeMode, Mousewheel]}
        mousewheel={true}
        slidesPerView={'auto'}
        spaceBetween={16}
      >
        {orderedFilters.map(tab => {
          const { key, label } = tab;

          return (
            <SwiperSlide key={key} onClick={() => onFilterChange(tab)}>
              <div
                className={classnames(
                  'filter-opening-state__tab',
                  activeTab.key === key && 'filter-opening-state__tab--active',
                )}
              >
                {label} {filtersResultsCount[key] >= 0 ? `(${numberWithCommas(filtersResultsCount[key])})` : ''}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      <span className="filter-opening-state__gradient" />
    </div>
  );
};
